import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  microsoftAuthApiRef,
  configApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { azurePolicyApiRef, AzurePolicyClient } from './api';

export const azPolicyPlugin = createPlugin({
  id: 'az-policy',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: azurePolicyApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        microsoftAuthApi: microsoftAuthApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, fetchApi, microsoftAuthApi, configApi }) =>
        new AzurePolicyClient({
          discoveryApi,
          fetchApi,
          microsoftAuthApi,
          config: configApi,
        }),
    }),
  ],
});

export const AzPolicyPage = azPolicyPlugin.provide(
  createRoutableExtension({
    name: 'AzPolicyPage',
    component: () =>
      import('./components/AzurePolicyOverview').then(
        m => m.AzurePolicyOverview,
      ),
    mountPoint: rootRouteRef,
  }),
);
